import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PagePermissions from './PagePermissions';

const UserAdminRouter = () => {
  return (
    <Switch>
      <Route path="/UST6" component={PagePermissions} />
    </Switch>
  );
};

export default UserAdminRouter;
